import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericProductSuggest from '../../../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../../../containers/Common/TypeRadios';

const propTypes = {
  productSearchType: PropTypes.string,
  suggestValue: PropTypes.string,
  selectedProduct: PropTypes.shape({
    inStock: PropTypes.number,
    purchased: PropTypes.number,
    presale: PropTypes.number,
    net_weight: PropTypes.number,
    ship_weight: PropTypes.number,
    PriceLv1: PropTypes.number,
    PriceLv2: PropTypes.number,
    PriceLv3: PropTypes.number,
    PriceLv4: PropTypes.number,
    PriceLv5: PropTypes.number,
    currentProdName: PropTypes.string,
    currentProdNum: PropTypes.string,
    currentProductDescription: PropTypes.string,
    currentRefNum: PropTypes.string,
    currentUnitType: PropTypes.string,
    currentPackageSize: PropTypes.string,
    currentProductWeight: PropTypes.number,
    currentProductCRV: PropTypes.number,
    currentProductTaxable: PropTypes.string,
  }),
  handleOptionChange: PropTypes.func,
  handleProductSuggestChange: PropTypes.func,
  selectInventoryInfo: PropTypes.func,
};

const defaultProps = {
  productSearchType: '',
  suggestValue: '',
  selectedProduct: {},
  handleOptionChange: () => {},
  handleProductSuggestChange: () => {},
  selectInventoryInfo: () => {},
};

const PromotionsProductSearch = ({
  productSearchType,
  handleOptionChange,
  suggestValue,
  handleProductSuggestChange,
  selectInventoryInfo,
  selectedProduct,
}) => (
  <div className="product-section">
    <Row>
      <Col xs={12}>
        <TypeRadios
          value={productSearchType}
          handleOptionChange={(event) => {
            handleOptionChange(event, 'productSearchType');
          }}
        />
      </Col>
      <Col xs={12} id="promotions-auto-suggest">
        <div className="control-dropdown">
          <GenericProductSuggest
            value={suggestValue}
            onChange={(e, { newValue }) => handleProductSuggestChange(e, newValue, 'suggestValue')}
            SearchType={productSearchType}
            fetchOrdersByProduct={(productNum, selectedInventoryRow) => {
              selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProduct');
            }}
          />
        </div>
      </Col>
      <Col xs={12}>
        <div className="product-details">
          <div className="product-details-left">
            <div className="flex-row">
              <label htmlFor="prod-num"><Translate value="prod_num" />:</label>
              <span>{ selectedProduct.currentProdNum }</span>
            </div>
            <div className="flex-row">
              <label htmlFor="ref-num"><Translate value="ref_num" />:</label>
              <span>{ selectedProduct.currentRefNum }</span>
            </div>
            <div className="flex-row">
              <label htmlFor="name" className="item-name-label"><Translate value="name" />: </label>
              <span className="item-name-span">{ selectedProduct.currentProdName }</span>
            </div>
            <div className="flex-row">
              <label htmlFor="description"><Translate value="desc" />: </label>
              { selectedProduct.currentProductDescription }
            </div>
          </div>
          <div className="product-details-right">
            <div className="flex-row">
              <label htmlFor="unit-type"><Translate value="unit_type" />:</label>
              { selectedProduct.currentUnitType }
            </div>
            <div className="flex-row">
              <label htmlFor="package-size"><Translate value="package_size" />:</label>
              { selectedProduct.currentPackageSize }
            </div>
            <div className="flex-row">
              <label htmlFor="weight"><Translate value="weight" />:</label>
              { selectedProduct.currentProductWeight }
            </div>
            <div className="flex-row">
              <label htmlFor="price"><Translate value="ref_price" />:</label>
              { (selectedProduct.currentRefPrice) ? `$${parseFloat(selectedProduct.currentRefPrice).toFixed(2)}` : '' }
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
);

PromotionsProductSearch.propTypes = propTypes;
PromotionsProductSearch.defaultProps = defaultProps;

export default PromotionsProductSearch;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/PromotionsProductSearch.jsx